module.exports = __webpack_public_path__ + "sprstatic/img/guoqi.0087e9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BidSecurity/guoqi.png
// module id = daTz
// module chunks = 2